import { render, staticRenderFns } from "./Add_factor_answer.vue?vue&type=template&id=82517dae"
import script from "./Add_factor_answer.vue?vue&type=script&lang=js"
export * from "./Add_factor_answer.vue?vue&type=script&lang=js"
import style0 from "./Add_factor_answer.vue?vue&type=style&index=0&id=82517dae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports